import { observer } from 'mobx-react'
import type { VehicleAvailability as VehicleAvailabilityType } from 'models/Vehicles/VehicleAvailabilityModel'
import { Row } from '../Table/Table'
import { BodyText } from '../Typography/Typography'

interface VehicleAvailabilityProps {
    vehicleAvailability: VehicleAvailabilityType
}

export const VehicleAvailability = observer(({ vehicleAvailability }: VehicleAvailabilityProps) => (
    <Row>
        <BodyText>Availability:   &nbsp;&nbsp;
            {vehicleAvailability.availableDays ?? "∞"} Days   &nbsp;&nbsp;| &nbsp;&nbsp;
            {vehicleAvailability.availableFlights ?? "∞"} Flights   &nbsp;&nbsp;| &nbsp;&nbsp;
            {vehicleAvailability.availableFlightHours ?? "∞"} Flight Hours
        </BodyText>
    </Row>
))
